export const APPLICATION_MODULE_KEY = {
  dashboard: 'dashboard',
  calendar: 'calendar',
  patients: 'patients',
  clients: 'clients',
  settings: 'settings',
  consultation: 'consultation',
  notes: 'notes',
  plans: 'plans',
  library: 'library',
  devices: 'devices',
  files: 'files',
  gdpr: 'gdpr',
  exercises: 'exercises',
  reports: 'reports',
  googleSync: 'googleSync',
} as const;

export type ApplicationModuleKey =
  (typeof APPLICATION_MODULE_KEY)[keyof typeof APPLICATION_MODULE_KEY];

export type EnabledModulesState = Record<ApplicationModuleKey, boolean>;
